export default __webpack_public_path__ + "static/media/placeholder.6c898a59.png";